import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import { SUPPORTED_CURRENCIES } from "helpers/currency";

dayjs.extend(customParseFormat);

export const currencyOptions = SUPPORTED_CURRENCIES.map((code) => ({
  label: code,
  value: code,
}));
export const FEE_TYPE_SUBSCRIPTION = "SUBSCRIPTION";
export const FEE_TYPE_FIXED_FEE = "AMOUNT";
export const feeTypeOptions = [
  { label: "Абонамент", value: FEE_TYPE_SUBSCRIPTION },
  { label: "Фиксирана такса", value: FEE_TYPE_FIXED_FEE },
];

/** Display label for a fee type value shown in tables (falls back to the raw value). */
export const feeTypeLabel = (value) =>
  feeTypeOptions.find((option) => option.value === value)?.label || value;

const dbStringFormat = "YYYY-MM-DDTHH:mm:ss.SSSZ";
export const dateHelper = (
  dateStr,
  format = "DD/MM/YYYY HH:mm:ss",
  defaultValue = "-",
) => {
  if (!dateStr) {
    return defaultValue;
  }
  const date = dayjs(dateStr, dbStringFormat);
  if (!date.isValid()) {
    return defaultValue;
  }
  return date.format(format);
};

// The API stores an open-ended fee with `validTo: null`, not a missing field.
export const isValidFee = (validFromStr, validToStr) => {
  if ((validFromStr ?? "").trim() === "" && (validToStr ?? "").trim() === "") {
    // no validation is set, assume permanently valid
    return true;
  }
  const validFrom = dayjs(validFromStr, dbStringFormat);
  const validTo = dayjs(validToStr, dbStringFormat);
  if (!validFrom.isValid() && !validTo.isValid()) {
    // invalid date strings
    return false;
  }
  const today = dayjs();
  let isValid = true;
  if (validFrom.isValid() && validFrom.isAfter(today)) {
    isValid = false;
  }
  if (validTo.isValid() && validTo.isBefore(today)) {
    isValid = false;
  }
  return isValid;
};
